<template>
  <div>
    <Form inline class="i-form">
      <FormItem label="结账月份" :label-width="100">
        <Select v-model="queryParams.settleDate" clearable c style="width:150px">
          <Option v-for="(item, index) in checkoutMonth" :key="index" :value="item.settleDate">{{ item.settleDate }}</Option>
        </Select>
      </FormItem>
      <FormItem label="业主" :label-width="100">
        <Input type="text" v-model.trim="queryParams.owner" placeholder="姓名/手机号"></Input>
      </FormItem>
      <FormItem label="门店" :label-width="76">
        <Select v-model="queryParams.chainId" clearable filterable placeholder="id/名称 输入下拉选择" style="width:250px">
          <Option v-for="(item, index) in allHotels" :key="index" :value="item.chainId">{{ `${item.chainId}_${item.chainName}` }}</Option>
        </Select>
      </FormItem>
      <FormItem label="Xbed房间id" :label-width="120">
        <Input type="text" v-model.trim="queryParams.roomId"></Input>
      </FormItem>
      <br>
      <FormItem>
        <Button type="primary" @click="handleBtn" style="margin-left: 32px; width: 100px;">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="exportReport" :loading="exportLoading" style="margin-left: 32px; min-width: 125px;">导出筛选结果</Button>
      </FormItem>
    </Form>
    <!-- Table-->
    <Content>
      <Table stripe :loading="consumloading" :columns="columns" :data="monthlySummaryData" style="width:1615px;"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page 
          show-sizer 
          show-total
          placement="top" 
          :total="listCount" 
          :current="queryParams.pageNum" 
          :page-size="queryParams.pageSize"
          @on-page-size-change="changePageSize" 
          @on-change="changePage"
        >
        </Page>
      </div>
    </Content>
  </div>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api";
import Config from "@/config";

export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");
    this.headerENV = Utils.aliHeaderEnv(this.env)
	},

  data () {
    return {
      consumloading: false,
      exportLoading: false, // 导出按钮loading
      // 传给接口的查询字段
      queryParams: {
        settleDate: Moment().format('YYYY-MM'),
        owner: '',
        chainId: '',
        roomId: '',
        pageNum: 1, // 当前页数
        pageSize: 10 // 每页显示的条数
      },
      monthlySummaryData: [], // 表格列表数据
      listCount: 0, // 分页
      columns: [
        {
          title: '操作',
          key: '',
          align: "center",
          width: 130,
          render: ( h, params ) => {
						return h( "div", [
							h(
								"a",
								{
									on: {
										click: () => {
											if ( !Utils.hasPermission( 'outConsumptions_settlementBillsReport' ) ) {
												this.$Notice.error( {
													title: "无权限操作"
												} );
                        return
											}
                      if ( this.$router ) {
                        window.open( `#/app/report/MonthlySettleDetail?settleDate=${ params.row.settleDate }&ownerId=${ params.row.ownerId }&roomId=${ params.row.roomId }&owner=${params.row.ownerName}` )      //跳转至管家库存明细表 
                      } else {
                        window.open( `#/Report/Report/monthlySettleDetail?settleDate=${ params.row.settleDate }&ownerId=${ params.row.ownerId ? params.row.ownerId : "-1" }&roomId=${ params.row.roomId }&owner=${params.row.ownerName}` )
                      }
										}
									}
								},
								"查看明细"
							)
						] );
					}
        },
        {
          title: '结算状态',
          key: 'settlementStatus',
          align: "center",
          width: 130,
          render:(h,params)=>{
            return h('div',{}, params.row.settlementStatus ? params.row.settlementStatus : '-')
          }
        },
        {
          title: '结账月份',
          key: 'settleDate',
          align: "center",
          width: 130,
          render:(h,params)=>{
            return h('div',{}, params.row.settleDate ? params.row.settleDate : '-')
          }
        },
        {
          title: '房间',
          key: 'roomName',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('div',{}, params.row.roomName ? params.row.roomName : '-')
          }
        },
        {
          title: '门店',
          key: 'chainName',
          align: "center",
          width: 230,
          render:(h,params)=>{
            return h('div',{}, params.row.chainName ? params.row.chainName : '-')
          }
        },
        {
          title: '业主',
          key: 'ownerName',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('div',{}, params.row.ownerName ? params.row.ownerName : '-')
          }
        },
        {
          title: '总结算金额',
          key: 'settlementPriceSum',
          align: "center",
          width: 150,
          render: (h, params) => {
            let price = params.row.settlementPriceSum ? (params.row.settlementPriceSum/100).toFixed(2) : '0'
            return h('div', {}, price)
          }
        },
        {
          title: '房费',
          key: '',
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", {
              attrs: {
                class: 'ivu-price'
              }
            },[
              h(
                "p", `消费金额：${params.row.roomChargeRealPrice ? (params.row.roomChargeRealPrice/100).toFixed(2) : '0'}`
              ),
              h(
                "p", `结算金额：${params.row.roomChargeSettlementPrice ? (params.row.roomChargeSettlementPrice/100).toFixed(2) : '0'}`
              )
            ])
          }
        },
        {
          title: '非房费收入',
          key: '',
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", {
              attrs: {
                class: 'ivu-price'
              }
            },[
              h(
                "p", `消费金额：${params.row.noRoomChargeRealPrice ? (params.row.noRoomChargeRealPrice/100).toFixed(2) : '0'}`
              ),
              h(
                "p", `结算金额：${params.row.noRoomChargeSettlementPrice ? (params.row.noRoomChargeSettlementPrice/100).toFixed(2) : '0'}`
              )
            ])
          }
        },
        {
          title: '销售费用',
          key: '',
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", {
              attrs: {
                class: 'ivu-price'
              }
            },[
              h(
                "p", `消费金额：${params.row.marketChargeRealPrice ? (params.row.marketChargeRealPrice/100).toFixed(2) : '0'}`
              ),
              h(
                "p", `结算金额：${params.row.marketChargeSettlementPrice ? (params.row.marketChargeSettlementPrice/100).toFixed(2) : '0'}`
              )
            ])
          }
        },
        {
          title: '维护费用',
          key: '',
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", {
              attrs: {
                class: 'ivu-price'
              }
            },[
              h(
                "p", `消费金额：${params.row.maintainChargeRealPrice ? (params.row.maintainChargeRealPrice/100).toFixed(2) : '0'}`
              ),
              h(
                "p", `结算金额：${params.row.maintainChargeSettlementPrice ? (params.row.maintainChargeSettlementPrice/100).toFixed(2) : '0'}`
              )
            ])
          }
        },
        {
          title: '管理费用',
          key: '',
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", {
              attrs: {
                class: 'ivu-price'
              }
            },[
              h(
                "p", `消费金额：${params.row.adminChargeRealPrice ? (params.row.adminChargeRealPrice/100).toFixed(2) : '0'}`
              ),
              h(
                "p", `结算金额：${params.row.adminChargeSettlementPrice ? (params.row.adminChargeSettlementPrice/100).toFixed(2) : '0'}`
              )
            ])
          }
        }
      ]
    }
  },

  props: {
    // 所有门店下拉框数据
    allHotels: {
      type: Array,
      default() {
        return []
      }
    },

    // 所有结账月份
    checkoutMonth: {
      type: Array,
      default() {
        return []
      }
    }
  },

  mounted() {
    this.$Notice.config({
			top: 150
    });
    if ( !Utils.hasPermission( 'oms_accountBill_settlementMonthReport' ) ) {
      this.$Notice.error( {
        title: "无权限操作"
      } );
      return
    }
    this.getMonthlySummaryReport()
  },

  methods: {
    // 结算报表列表 - 月度结算汇总
    async getMonthlySummaryReport() {
      this.consumloading = true
      let _queryParams = this.queryParams
      // 过滤空字段
      _queryParams = Object.keys(_queryParams).reduce(function(c, k) {
        if (_queryParams[k] && _queryParams[k] != -1 ) {
          c[k] = _queryParams[k]
        }
        return c
      }, {})

      try {
        const resp = (await API.omsAPI[this.env].clientServer.getSettlementMonthReport(_queryParams, {'x-ca-stage':this.headerENV, 'Authorization':this.AuthorToken, 'Right': this.token})).data;
        this.consumloading = false
        if ( resp.retCode ) {
          this.$Notice.error( {
            title: resp.msg,
            desc: '获取结算账单报表数据异常'
          })
          return
        }
        this.monthlySummaryData = resp.list || []
        this.listCount = resp.total
      } catch(e) {
        this.consumloading = false
      }
    },

    handleBtn() {
      this.queryParams.pageNum = 1
      this.getMonthlySummaryReport()
    },

    // 分页
    changePageSize(pageSize) {
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = pageSize
      this.getMonthlySummaryReport()
    },
    changePage(pageIndex) {
      this.queryParams.pageNum = pageIndex
      this.getMonthlySummaryReport()
    },
    
    // 导出
    exportReport(){
      // if ( !Utils.hasPermission( 'outConsumptions_settlementMonthExport' ) ) {
      //   this.$Notice.error( {
      //     title: "无权限操作"
      //   } );
      //   return
      // }
      if (!this.monthlySummaryData.length) {
        this.$Notice.warning( {
          title: "无数据符合当前筛选条件，请调整"
        } );
        return
      }
      // 过滤空字段并拼接参数
      const initParam = params => {
				let paramStr = '';
				Object.keys( params ).forEach( item => {
					if ( params[item] && params[item] != -1 ) {
						paramStr += item + '=' + params[item] + '&';
					}
				} )
				return paramStr.substring( 0, paramStr.lastIndexOf( '&' ) );
			}
      let paramsInfos = initParam( this.queryParams);
			let url = `${ Config[this.env].accountUrl }outConsumptions/settlementMonthExport?${ paramsInfos }`;
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, 'exportLoading' )
    }

  }
}
</script>

<style lang="scss">
.ivu-price {
  padding: 10px 0px;
  line-height: 25px;
  p {
    margin: 0;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/report/bill-statement/monthly-summary.vue